import jWeixin from 'wecomjsdk'
// 获得企业ticket
async function getTicket() {
  let userId = uni.getStorageSync('userId')
  let corpId = uni.getStorageSync('corpId')
  const data = await getApp().globalData.$universalAsk.get(`/enterprise/cgi-bin/get_jsapi_ticket`, {
    suiteid: getApp().globalData.$suiteId,
    corpid: corpId,
  })
  if (data._status === 200) {
    let noncestr = randomString(17);
    let timestamp = Date.parse(new Date()) / 1000;
    let url = window.location.href.split('#')[0];
    let params = {
      'jsapi_ticket': data.suite_ticket,
      'noncestr': noncestr,
      'timestamp': timestamp,
      'url': url
    };
    let signstr = '';
    for (let item in params) {
      signstr += item + '=' + params[item] + '&'
    }
    signstr = signstr.substr(0, signstr.length - 1);
    // alert(signstr)
    jWeixin.config({
      beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: corpId, // 必填，企业微信的corpID
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: noncestr, // 必填，生成签名的随机串
      signature: sha1(signstr), // 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList: ['selectEnterpriseContact', 'getCurExternalContact', 'getContext', 'sendChatMessage', 'openUserProfile'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    });

    jWeixin.ready(function() {
      // resolve(wx);
      // alert('success');
      getApp().globalData.$wx_config = true
    })

    jWeixin.error(res => {
      getApp().globalData.$wx_config = false
      // reject(res);
      console.log('微信注册失败：' + res);
    })
  }
}
// 获得应用ticket
async function getApplicationTicket() {
  let userId = uni.getStorageSync('userId')
  let corpId = uni.getStorageSync('corpId')
  const data = await getApp().globalData.$universalAsk.get(`/enterprise/cgi-bin/application/get_jsapi_ticket`, {
    suiteid: getApp().globalData.$suiteId,
    corpid: corpId,
  })
  if (data._status === 200) {
    let noncestr = randomString(17);
    let timestamp = Date.parse(new Date()) / 1000;
    let url = window.location.href.split('#')[0];
    let params = {
      'jsapi_ticket': data.suite_ticket,
      'noncestr': noncestr,
      'timestamp': timestamp,
      'url': url
    };
    uni.setStorageSync('agentid', data.agentid);
    let signstr = '';
    for (let item in params) {
      signstr += item + '=' + params[item] + '&'
    }
    signstr = signstr.substr(0, signstr.length - 1);
    jWeixin.agentConfig({
      corpid: corpId,
      agentid: data.agentid,
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: noncestr, // 必填，生成签名的随机串
      signature: sha1(signstr), // 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList: ['selectEnterpriseContact', 'getCurExternalContact', 'getContext', 'sendChatMessage', 'openUserProfile'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    });

    jWeixin.ready(function() {
      // resolve(wx);
      // alert('success');
      getApp().globalData.$wx_agentConfig = true
    })

    jWeixin.error(res => {
      getApp().globalData.$wx_agentConfig = false
      // reject(res);
      console.log('微信注册失败：' + res);
    })
  }
}
//生成随机字符串
function randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}
// 字符串加密成 hex 字符串
function sha1(s) {
    var data = new Uint8Array(encodeUTF8(s))
    var i, j, t;
    var l = ((data.length + 8) >>> 6 << 4) + 16,
        s = new Uint8Array(l << 2);
    s.set(new Uint8Array(data.buffer)), s = new Uint32Array(s.buffer);
    for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2);
    s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
    s[l - 1] = data.length << 3;
    var w = [],
        f = [
            function() {
                return m[1] & m[2] | ~m[1] & m[3];
            },
            function() {
                return m[1] ^ m[2] ^ m[3];
            },
            function() {
                return m[1] & m[2] | m[1] & m[3] | m[2] & m[3];
            },
            function() {
                return m[1] ^ m[2] ^ m[3];
            }
        ],
        rol = function(n, c) {
            return n << c | n >>> (32 - c);
        },
        k = [1518500249, 1859775393, -1894007588, -899497514],
        m = [1732584193, -271733879, null, null, -1009589776];
    m[2] = ~m[0], m[3] = ~m[1];
    for (i = 0; i < s.length; i += 16) {
        var o = m.slice(0);
        for (j = 0; j < 80; j++)
            w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1),
            t = rol(m[0], 5) + f[j / 20 | 0]() + m[4] + w[j] + k[j / 20 | 0] | 0,
            m[1] = rol(m[1], 30), m.pop(), m.unshift(t);
        for (j = 0; j < 5; j++) m[j] = m[j] + o[j] | 0;
    };
    t = new DataView(new Uint32Array(m).buffer);
    for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2);

    var hex = Array.prototype.map.call(new Uint8Array(new Uint32Array(m).buffer), function(e) {
        return (e < 16 ? "0" : "") + e.toString(16);
    }).join("");
    return hex;
}
function encodeUTF8(s) {
    var i, r = [],
        c, x;
    for (i = 0; i < s.length; i++)
        if ((c = s.charCodeAt(i)) < 0x80) r.push(c);
        else if (c < 0x800) r.push(0xC0 + (c >> 6 & 0x1F), 0x80 + (c & 0x3F));
    else {
        if ((x = c ^ 0xD800) >> 10 == 0) //对四字节UTF-16转换为Unicode
            c = (x << 10) + (s.charCodeAt(++i) ^ 0xDC00) + 0x10000,
            r.push(0xF0 + (c >> 18 & 0x7), 0x80 + (c >> 12 & 0x3F));
        else r.push(0xE0 + (c >> 12 & 0xF));
        r.push(0x80 + (c >> 6 & 0x3F), 0x80 + (c & 0x3F));
    };
    return r;
}
function UrlEncode(str){
  let output = '';
  let x = 0;
  let clearString = str.toString();
  var regex = /(^[a-zA-Z0-9-_.]*)/;
  while (x < clearString.length) {
    var match = regex.exec(clearString.substr(x));
    if (match != null && match.length > 1 && match[1] != '') {
      output += match[1];
      x += match[1].length;
    } else {
      if (clearString.substr(x, 1) == ' ') {
        //原文在此用 clearString[x] == ' ' 做判断, 但ie不支持把字符串当作数组来访问,
        //修改后两种浏览器都可兼容
        output += '+';
      }
      else {
        let charCode = clearString.charCodeAt(x);
        let hexVal = charCode.toString(16);
        output += '%' + ( hexVal.length < 2 ? '0' : '' ) + hexVal.toUpperCase();
      }
      x++;
    }
  }
  return output;
}
async function authorization() {
  const data = await getApp().globalData.$universalAsk.get(`/enterprise/cgi-bin/get_auth_code`, {
    suiteid: getApp().globalData.$suiteId
  })
  window.location.href = `https://open.work.weixin.qq.com/3rdapp/install?suite_id=${ getApp().globalData.$suiteId }&pre_auth_code=${ data.pre_auth_code }&redirect_uri=${ UrlEncode('https://middleground.fenxiangqu.cn/api-universal/enterprise/retrun_auth_code') }&state=${ getApp().globalData.$suiteId }`
}
async function buildAuthorization() {
  let url = window.location.href.split('#')[0];
  let buildUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${ getApp().globalData.$suiteId }&redirect_uri=${ UrlEncode(url) }&response_type=code&scope=snsapi_privateinfo&state=STATE#wechat_redirect`
  window.location.href = buildUrl
}
module.exports = {
  initWxConfig: getTicket,
  initAgentConfig: getApplicationTicket,
  authorization: authorization,
  buildAuthorization: buildAuthorization
}
